
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.54 45.44h1.89a9.218 9.218 0 007.63 4.08 2.38 2.38 0 002.38-2.38V32.86a2.38 2.38 0 00-2.38-2.38 9.216 9.216 0 00-7.63 4.08h-1.89a3.74 3.74 0 00-3.74 3.74v3.4a3.74 3.74 0 003.74 3.74zm-1.7-7.14a1.7 1.7 0 011.7-1.7h2.454c.365 0 .703-.194.885-.51a7.167 7.167 0 016.18-3.57.34.34 0 01.34.34v14.28a.34.34 0 01-.34.34 7.167 7.167 0 01-6.18-3.57 1.02 1.02 0 00-.885-.51H33.54a1.7 1.7 0 01-1.7-1.7v-3.4z"}}),_c('path',{attrs:{"d":"M47.417 30.005l1.443 1.442L29.788 50.52l-1.442-1.442 19.071-19.072z"}})])
          )
        }
      }
    